import { render } from "./PatientDataSharingRequest.vue?vue&type=template&id=8f8f75e0"
import script from "./PatientDataSharingRequest.vue?vue&type=script&lang=js"
export * from "./PatientDataSharingRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__